import IconAccounting from "../../components/icons/IconAccounting";
import IconAmazonPo from "../../components/icons/IconAmazonPo";
import IconApiKey from "../../components/icons/IconApiKey";
import IconArContacts from "../../components/icons/IconArContacts";
import IconBaldor from "../../components/icons/IconBaldor";
import IconCategoryAndCollection from "../../components/icons/IconCategoryAndCollection";
import IconCloseHub from "../../components/icons/IconCloseHub";
import IconContainer from "../../components/icons/IconContainer";
import IconCreateWarehouseReturn from "../../components/icons/IconCreateWarehouseReturn";
import IconCsReturn from "../../components/icons/IconCsReturn";
import IconDashboard from "../../components/icons/IconDashboard";
import IconEdi from "../../components/icons/IconEdi";
import IconHelp from "../../components/icons/IconHelp";
import IconIncomingInventory from "../../components/icons/IconIncomingInventory";
import IconInventory from "../../components/icons/IconInventory";
import IconJobs from "../../components/icons/IconJobs";
import IconLeadership from "../../components/icons/IconLeadership";
import IconLifeCycle from "../../components/icons/IconLifeCycle";
import IconMarketing from "../../components/icons/IconMarketing";
import IconMaterialCombination from "../../components/icons/IconMaterialCombination";
import IconOrders from "../../components/icons/IconOrders";
import IconPendingCatalog from "../../components/icons/IconPendingCatalog";
import IconProductExport from "../../components/icons/IconProductExport";
import IconProducts from "../../components/icons/IconProducts";
import IconPurchaseOrder from "../../components/icons/IconPurchaseOrder";
import IconPurchasing from "../../components/icons/IconPurchasing";
import IconReturn from "../../components/icons/IconReturn";
import IconSalesExport from "../../components/icons/IconSalesExport";
import IconSalesOrders from "../../components/icons/IconSalesOrders";
import IconSampleOrder from "../../components/icons/IconSampleOrder";
import IconShipment from "../../components/icons/IconShipment";
import IconShipmentMenu from "../../components/icons/IconShipmentMenu";
import IconShipments from "../../components/icons/IconShipments";
import IconShippingPrices from "../../components/icons/IconShippingPrices";
import IconSourcing from "../../components/icons/IconSourcing";
import IconSpecification from "../../components/icons/IconSpecification";
import IconSpi from "../../components/icons/IconSpi";
import IconStagedOrders from "../../components/icons/IconStagedOrders";
import IconStock from "../../components/icons/IconStock";
import IconUsFoods from "../../components/icons/IconUsFoods";
import IconVariationGrouping from "../../components/icons/IconVariationGrouping";
import IconVendors from "../../components/icons/IconVendors";
import IconViewJobs from "../../components/icons/IconViewJobs";
import IconViewReturn from "../../components/icons/IconViewReturn";
import {
  adminRouteId,
  allProductsInventoryRouteId,
  amazonAdsRouteId,
  amazonCanadaRouteId,
  amazonDfRouteId,
  amazonPoRouteId,
  amazonRouteId,
  amazonSellerRouteId,
  apiKeysRouteId,
  archivedInventoryRouteId,
  arContactsRouteId,
  asanaPurchasingRouteId,
  asanaSourcingRouteId,
  baldorDfRouteId,
  baldorRouteId,
  baldorWarehouseRouteId,
  bradyRouteId,
  categoryAndCollectionRouteId,
  ceoPricingRouteId,
  chefsWarehouseRouteId,
  closeHubRouteId,
  compassRouteId,
  containerRouteId,
  createCsReturnRouteId,
  cwDirectRouteId,
  cwDropshipRouteId,
  cwStagedOrdersRouteId,
  cwStockRouteId,
  distributorRouteId,
  ediDashboardRouteId,
  enrichProduct,
  europeanImportsRouteId,
  fourSeasonsRouteId,
  gfsCanadaRouteId,
  gfsRouteId,
  gfsStoresRouteId,
  gfsUsRouteId,
  ideationProduct,
  incomingInventoryRouteId,
  inStockRouteId,
  jetfreshRouteId,
  jobsRouteId,
  kpiDashboardRouteId,
  legendsRouteId,
  materialCombinationRouteId,
  northwoodRouteId,
  ordersRouteId,
  outOfStockRouteId,
  pendingCatalogsRouteId,
  poRouteId,
  produceProRouteId,
  productExportRouteId,
  returnRouteId,
  salesExportRouteId,
  sampleOrdersRouteId,
  shipmentDashboardRouteId,
  shipmentRouteId,
  shipmentsAmazonPoCanadaRouteId,
  shipmentsAmazonPoRouteId,
  shipmentsBaldorRouteId,
  shipmentsUsFoodsRouteId,
  shippingPricesRouteId,
  singerEquipmentRouteId,
  sodexoRouteId,
  sotfRouteId,
  specificationRouteId,
  stagedOrdersRouteId,
  storeFrontRouteId,
  syscoDirectRouteId,
  syscoRouteId,
  taoGroupRouteId,
  unknownReturnRouteId,
  usFoodsCsRouteId,
  usFoodsDirectRouteId,
  usFoodsRouteId,
  usFoodsUsRouteId,
  variationGroupingRouteId,
  vendorsRouteId,
  warehouseReturnRouteId,
  zoroRouteId,
} from "../../constants/routePermissions";
import { APP_ROUTES } from "../../constants/routes";
import type { MenuItem } from "./types";

/**
 * Mirrors the structure of RW-ERP-Service/src/components/navigation/AsideMenu.vue.
 *
 * Top-level items appear in the icon rail. Their `children` populate the
 * panel beside the rail. Children may have their own `children` for one
 * further level (e.g. Sales orders > Sysco > European Imports).
 *
 * Only `ar-contacts` is `isReactRoute: true`; every other route resolves
 * against the Vue ERP origin via `navigateToVueRoute`.
 */
export const MENU_CONFIG: ReadonlyArray<MenuItem> = [
  {
    id: "dashboard",
    label: "Dashboard",
    labelKey: "menu.dashboard",
    icon: IconDashboard,
    children: [
      // Vue parity — AsideMenu.vue:474-479 lists KPI BEFORE EDI under
      // the Dashboard parent. The emulated-user scenario where the
      // user has KPI permission but not EDI used to drop the entire
      // Dashboard branch in React (single child filtered → parent
      // dropped). Adding KPI here closes that divergence.
      {
        id: "kpi-dashboard",
        label: "KPI",
        labelKey: "menu.kpi",
        // No dedicated IconKpi in React yet — fall back to the parent
        // IconDashboard. Swap when an IconKpi component is added.
        icon: IconDashboard,
        // Vue's deep link to the default KPI dashboard (AsideMenu.vue:478).
        // Permission check uses `/dashboard` per Vue's special-case at
        // AsideMenu.vue:1346-1350 — see comment on `kpiDashboardRouteId`
        // in routePermissions.ts. We register BOTH paths in
        // ROUTE_PERMISSIONS so the permission lookup hits either way.
        route: "/dashboard",
        routeId: kpiDashboardRouteId,
        isReactRoute: false,
      },
      {
        id: "edi-dashboard",
        label: "EDI Dashboard",
        labelKey: "menu.ediDashboard",
        icon: IconEdi,
        route: "/dashboard/edi",
        routeId: ediDashboardRouteId,
        isReactRoute: false,
      },
      {
        id: "sales-summary",
        label: "Sales Summary",
        labelKey: "menu.salesSummary",
        icon: IconDashboard,
        route: APP_ROUTES.salesSummary,
        routeId: kpiDashboardRouteId,
        isReactRoute: true,
      },
      {
        id: "sales-breakdown",
        label: "Sales Breakdown",
        labelKey: "menu.salesBreakdown",
        icon: IconDashboard,
        route: APP_ROUTES.salesBreakdown,
        routeId: kpiDashboardRouteId,
        isReactRoute: true,
      },
    ],
  },
  {
    id: "orders",
    label: "Orders",
    labelKey: "menu.orders",
    icon: IconOrders,
    children: [
      {
        id: "sales-orders",
        label: "Sales orders",
        labelKey: "menu.salesOrders",
        icon: IconSalesOrders,
        routeId: distributorRouteId,
        // The breadcrumb for this group lands on All orders.
        landingRoute: "/orders/sales-orders/all",
        children: [
          {
            // First child of the Sales orders group. Lives at the
            // Vue-style URL `/orders/sales-orders/all` so the address
            // bar matches what the Vue ERP user already expects; the
            // route is registered above the `/orders/sales-orders/*`
            // wildcard in `AppRoutes.tsx` so the migrated React
            // `<Orders />` page renders here (not the ComingSoon stub).
            // The canonical `/orders` path still works as a direct-link
            // alias.
            id: "sales-orders-all",
            label: "All orders",
            labelKey: "menu.allOrders",
            route: "/orders/sales-orders/all",
            routeId: ordersRouteId,
            isReactRoute: true,
          },
          {
            id: "admin",
            label: "Admin",
            labelKey: "menu.admin",
            route: "/orders/sales-orders/admin",
            routeId: adminRouteId,
            isReactRoute: true,
          },
          {
            id: "amazon",
            label: "Amazon",
            labelKey: "menu.amazon",
            // Parent-group page: shows every Amazon sub-distributor's
            // orders via `distributorGroupId` (Vue parity —
            // `AsideMenu.vue` line 595, `routeLink: '/orders/sales-orders/amazon'`).
            route: "/orders/sales-orders/amazon",
            routeId: amazonRouteId,
            isReactRoute: true,
            children: [
              {
                id: "amazon-canada",
                label: "Amazon Canada",
                labelKey: "menu.amazonCanada",
                route: "/orders/sales-orders/amazon/amazon-canada",
                routeId: amazonCanadaRouteId,
                isReactRoute: true,
              },
              {
                id: "amazon-df",
                label: "Amazon DF",
                labelKey: "menu.amazonDf",
                route: "/orders/sales-orders/amazon/amazon-df",
                routeId: amazonDfRouteId,
                isReactRoute: true,
              },
              {
                id: "amazon-po",
                label: "Amazon PO",
                labelKey: "menu.amazonPo",
                route: "/orders/sales-orders/amazon/amazon-po",
                routeId: amazonPoRouteId,
                isReactRoute: true,
              },
              {
                id: "amazon-seller",
                label: "Amazon Seller Central",
                labelKey: "menu.amazonSellerCentral",
                route: "/orders/sales-orders/amazon/amazon-seller-central",
                routeId: amazonSellerRouteId,
                isReactRoute: true,
              },
            ],
          },
          {
            id: "baldor",
            label: "Baldor",
            labelKey: "menu.baldor",
            // Parent-group page — `distributorGroupId` (Vue parity:
            // `AsideMenu.vue` line 644, `routeLink: '/orders/sales-orders/baldor'`).
            route: "/orders/sales-orders/baldor",
            routeId: baldorRouteId,
            isReactRoute: true,
            children: [
              {
                id: "baldor-df",
                label: "Baldor DF",
                labelKey: "menu.baldorDf",
                route: "/orders/sales-orders/baldor/baldor-df",
                routeId: baldorDfRouteId,
                isReactRoute: true,
              },
              {
                id: "baldor-warehouse",
                label: "Baldor Warehouse",
                labelKey: "menu.baldorWarehouse",
                route: "/orders/sales-orders/baldor/baldor-warehouse",
                routeId: baldorWarehouseRouteId,
                isReactRoute: true,
              },
            ],
          },
          {
            id: "brady",
            label: "Brady",
            labelKey: "menu.brady",
            route: "/orders/sales-orders/brady",
            routeId: bradyRouteId,
            isReactRoute: true,
          },
          {
            id: "compass",
            label: "Compass",
            labelKey: "menu.compass",
            route: "/orders/sales-orders/compass",
            routeId: compassRouteId,
            isReactRoute: true,
          },
          {
            id: "cw",
            label: "CW",
            labelKey: "menu.cw",
            // Parent-group page (Vue's "ChefsWarehouse") — `distributorGroupId`
            // (Vue parity: `AsideMenu.vue` line 685, `routeLink: '/orders/sales-orders/chefswarehouse'`).
            route: "/orders/sales-orders/chefswarehouse",
            routeId: chefsWarehouseRouteId,
            isReactRoute: true,
            children: [
              {
                id: "cw-direct",
                label: "CW Direct",
                labelKey: "menu.cwDirect",
                route: "/orders/sales-orders/chefswarehouse/cw-direct",
                routeId: cwDirectRouteId,
                isReactRoute: true,
              },
              {
                id: "cw-dropship",
                label: "CW DropShip",
                labelKey: "menu.cwDropship",
                route: "/orders/sales-orders/chefswarehouse/cw-dropship",
                routeId: cwDropshipRouteId,
                isReactRoute: true,
              },
              {
                id: "cw-stock",
                label: "CW Stock",
                labelKey: "menu.cwStock",
                route: "/orders/sales-orders/chefswarehouse/cw-stock",
                routeId: cwStockRouteId,
                isReactRoute: true,
              },
            ],
          },
          {
            id: "four-seasons",
            label: "Four Seasons",
            labelKey: "menu.fourSeasons",
            route: "/orders/sales-orders/four-seasons",
            routeId: fourSeasonsRouteId,
            isReactRoute: true,
          },
          {
            id: "gfs",
            label: "GFS",
            labelKey: "menu.gfs",
            // Parent-group page: shows every GFS sub-distributor's orders
            // via `distributorGroupId` (Vue parity — `AsideMenu.vue` line 728,
            // `routeLink: '/orders/sales-orders/gfs'`). Was previously
            // missing, so clicking "GFS" only toggled the submenu and never
            // filtered by `distributorGroupId`.
            route: "/orders/sales-orders/gfs",
            routeId: gfsRouteId,
            isReactRoute: true,
            children: [
              {
                id: "gfs-canada",
                label: "GFS Canada",
                labelKey: "menu.gfsCanada",
                route: "/orders/sales-orders/gfs/gfs-canada",
                routeId: gfsCanadaRouteId,
                isReactRoute: true,
              },
              {
                id: "gfs-stores",
                label: "GFS Stores",
                labelKey: "menu.gfsStores",
                route: "/orders/sales-orders/gfs/gfs-stores",
                routeId: gfsStoresRouteId,
                isReactRoute: true,
              },
              {
                id: "gfs-us",
                label: "GFS US",
                labelKey: "menu.gfsUs",
                route: "/orders/sales-orders/gfs/gfs-us",
                routeId: gfsUsRouteId,
                isReactRoute: true,
              },
            ],
          },
          {
            id: "legends",
            label: "Legends",
            labelKey: "menu.legends",
            route: "/orders/sales-orders/legends",
            routeId: legendsRouteId,
            isReactRoute: true,
          },
          {
            id: "northwood",
            label: "Northwood",
            labelKey: "menu.northwood",
            route: "/orders/sales-orders/northwood",
            routeId: northwoodRouteId,
            isReactRoute: true,
          },
          {
            id: "produce-pro",
            label: "Produce Pro",
            labelKey: "menu.producePro",
            route: "/orders/sales-orders/produce-pro",
            routeId: produceProRouteId,
            isReactRoute: true,
          },
          {
            id: "singer-equipment",
            label: "Singer Equipment",
            labelKey: "menu.singerEquipment",
            route: "/orders/sales-orders/singer-equipment",
            routeId: singerEquipmentRouteId,
            isReactRoute: true,
          },
          {
            id: "sodexo",
            label: "Sodexo",
            labelKey: "menu.sodexo",
            route: "/orders/sales-orders/sodexo",
            routeId: sodexoRouteId,
            isReactRoute: true,
          },
          {
            id: "storefront",
            label: "Storefront",
            labelKey: "menu.storefront",
            route: "/orders/sales-orders/store-front",
            routeId: storeFrontRouteId,
            isReactRoute: true,
          },
          {
            id: "sysco",
            label: "Sysco",
            labelKey: "menu.sysco",
            // Parent-group page — `distributorGroupId` (Vue parity:
            // `AsideMenu.vue` line 809, `routeLink: '/orders/sales-orders/sysco'`).
            route: "/orders/sales-orders/sysco",
            routeId: syscoRouteId,
            isReactRoute: true,
            children: [
              {
                id: "european-imports",
                label: "European Imports",
                labelKey: "menu.europeanImports",
                route: "/orders/sales-orders/sysco/european-imports",
                routeId: europeanImportsRouteId,
                isReactRoute: true,
              },
              {
                id: "sotf",
                label: "SOTF",
                labelKey: "menu.sotf",
                route: "/orders/sales-orders/sysco/sotf",
                routeId: sotfRouteId,
                isReactRoute: true,
              },
              {
                id: "sysco-direct",
                label: "Sysco Direct",
                labelKey: "menu.syscoDirect",
                route: "/orders/sales-orders/sysco/sysco-direct",
                routeId: syscoDirectRouteId,
                isReactRoute: true,
              },
            ],
          },
          {
            id: "tao-group",
            label: "Tao Group",
            labelKey: "menu.taoGroup",
            route: "/orders/sales-orders/tao-group",
            routeId: taoGroupRouteId,
            isReactRoute: true,
          },
          {
            id: "us-foods",
            label: "US Foods",
            labelKey: "menu.usFoods",
            // Parent-group page — `distributorGroupId` (Vue parity:
            // `AsideMenu.vue` line 850, `routeLink: '/orders/sales-orders/us-foods'`).
            route: "/orders/sales-orders/us-foods",
            routeId: usFoodsRouteId,
            isReactRoute: true,
            children: [
              {
                id: "us-foods-us",
                label: "US Foods (US)",
                labelKey: "menu.usFoodsUs",
                route: "/orders/sales-orders/us-foods/us",
                routeId: usFoodsUsRouteId,
                isReactRoute: true,
              },
              {
                id: "us-foods-cs",
                label: "US Foods CS",
                labelKey: "menu.usFoodsCs",
                route: "/orders/sales-orders/us-foods/us-foods-cs",
                routeId: usFoodsCsRouteId,
                isReactRoute: true,
              },
              {
                id: "us-foods-direct",
                label: "US Foods Direct",
                labelKey: "menu.usFoodsDirect",
                route: "/orders/sales-orders/us-foods/us-foods-direct",
                routeId: usFoodsDirectRouteId,
                isReactRoute: true,
              },
            ],
          },
          {
            id: "zoro",
            label: "Zoro",
            labelKey: "menu.zoro",
            route: "/orders/sales-orders/zoro",
            routeId: zoroRouteId,
            // Served by the React Orders page (`DistributorOrComingSoon`),
            // like every other distributor listing on this branch.
            isReactRoute: true,
          },
        ],
      },
      {
        id: "staged-orders",
        label: "Staged orders",
        labelKey: "menu.stagedOrders",
        icon: IconStagedOrders,
        routeId: stagedOrdersRouteId,
        // The breadcrumb for this group lands on All orders.
        landingRoute: "/orders/staged-orders/all",
        children: [
          {
            id: "staged-all",
            label: "All orders",
            labelKey: "menu.allOrders",
            route: "/orders/staged-orders/all",
            routeId: stagedOrdersRouteId,
            isReactRoute: true,
          },
          {
            id: "staged-jetfresh",
            label: "JetFresh orders",
            labelKey: "menu.jetfreshOrders",
            route: "/orders/staged-orders/jetfresh",
            routeId: jetfreshRouteId,
            isReactRoute: true,
          },
          {
            // Vue parity — `AsideMenu.vue` line 903, `routeLink:
            // '/orders/staged-orders/cw-order'`, gated on the dedicated
            // `cwStagedOrdersRouteId` (NOT `stagedOrdersRouteId` — a
            // mismatch this entry used to carry; `ROUTE_PERMISSIONS`
            // already keyed this exact path to `cwStagedOrdersRouteId`).
            id: "staged-cw-order",
            label: "CW orders",
            labelKey: "menu.cwOrders",
            route: "/orders/staged-orders/cw-order",
            routeId: cwStagedOrdersRouteId,
            isReactRoute: true,
          },
        ],
      },
      {
        id: "report-export",
        label: "Report Export",
        labelKey: "menu.reportExport",
        icon: IconSalesExport,
        route: "/orders/report-export",
        routeId: salesExportRouteId,
        isReactRoute: false,
      },
      {
        id: "pending-catalogs",
        label: "Pending catalogs",
        labelKey: "menu.pendingCatalogs",
        icon: IconPendingCatalog,
        route: "/orders/pending-catalogs",
        routeId: pendingCatalogsRouteId,
        isReactRoute: false,
      },
      {
        id: "shipping-prices",
        label: "Shipping Prices",
        labelKey: "menu.shippingPrices",
        icon: IconShippingPrices,
        route: APP_ROUTES.shippingPrices,
        routeId: shippingPricesRouteId,
        isReactRoute: true,
      },
    ],
  },
  {
    // Vue parity — `AsideMenu.vue` key 'leadership', rendered between Orders
    // and Returns.
    id: "leadership",
    label: "Leadership",
    labelKey: "menu.leadership",
    icon: IconLeadership,
    children: [
      {
        id: "sample-orders",
        label: "Sample orders",
        labelKey: "menu.sampleOrders",
        icon: IconSampleOrder,
        route: "/leadership/sample-orders",
        routeId: sampleOrdersRouteId,
        isReactRoute: false,
      },
      {
        id: "shipment-dashboard",
        label: "Shipment Dashboard",
        labelKey: "menu.shipmentDashboard",
        icon: IconShipmentMenu,
        route: "/leadership/shipment-dashboard",
        routeId: shipmentDashboardRouteId,
        isReactRoute: false,
      },
    ],
  },
  {
    // Vue parity — `AsideMenu.vue` key 'returns'. Order of leaves matches
    // Vue: Create CS Return, Create Warehouse Return, Unknown Return, View
    // returns.
    id: "returns",
    label: "Returns",
    labelKey: "menu.returns",
    icon: IconReturn,
    children: [
      {
        id: "create-cs-return",
        label: "Create CS Return",
        labelKey: "menu.createCsReturn",
        icon: IconCsReturn,
        route: "/returns/create/customer-support",
        routeId: createCsReturnRouteId,
        isReactRoute: false,
      },
      {
        id: "create-warehouse-return",
        label: "Create warehouse return",
        labelKey: "menu.createWarehouseReturn",
        icon: IconCreateWarehouseReturn,
        route: "/returns/create/warehouse",
        routeId: warehouseReturnRouteId,
        isReactRoute: false,
      },
      {
        id: "create-unknown-return",
        label: "Unknown Return",
        labelKey: "menu.unknownReturn",
        icon: IconHelp,
        route: "/returns/create/unknown-return",
        routeId: unknownReturnRouteId,
        isReactRoute: false,
      },
      {
        id: "view-returns",
        label: "View returns",
        labelKey: "menu.viewReturns",
        icon: IconViewReturn,
        route: "/returns",
        routeId: returnRouteId,
        isReactRoute: false,
      },
    ],
  },
  {
    id: "products",
    label: "Products",
    labelKey: "menu.products",
    icon: IconProducts,
    children: [
      {
        id: "lifecycle",
        label: "Lifecycle",
        labelKey: "menu.lifecycle",
        icon: IconLifeCycle,
        children: [
          {
            id: "ideation",
            label: "Ideation",
            labelKey: "menu.ideation",
            route: "/product/ideation",
            routeId: ideationProduct,
            isReactRoute: false,
          },
          {
            id: "enrichment",
            label: "Enrichment",
            labelKey: "menu.enrichment",
            route: "/product/enrichment",
            routeId: enrichProduct,
            isReactRoute: false,
          },
          {
            id: "ceo-pricing",
            label: "CEO Pricing",
            labelKey: "menu.ceoPricing",
            route: APP_ROUTES.ceoPricing,
            routeId: ceoPricingRouteId,
            isReactRoute: true,
          },
        ],
      },
      {
        id: "specifications",
        label: "Specifications",
        labelKey: "menu.specifications",
        icon: IconSpecification,
        route: "/products/settings/specification",
        routeId: specificationRouteId,
        isReactRoute: false,
      },
      {
        id: "material-combinations",
        label: "Material Combinations",
        labelKey: "menu.materialCombinations",
        icon: IconMaterialCombination,
        // Was "/products/material-subtype" — doesn't exist in Vue's router.
        // Vue's real path is MATERIAL_SUBTYPE in
        // RW-ERP-Service/src/types/material/material-subtype-constants.ts,
        // which resolves to "/product/material-combinations". Same broken
        // redirect-loop pattern as All Products above.
        route: "/product/material-combinations",
        routeId: materialCombinationRouteId,
        isReactRoute: false,
      },
      {
        id: "category-and-collection",
        label: "Category & Collection",
        labelKey: "menu.categoryAndCollection",
        icon: IconCategoryAndCollection,
        route: "/product/category-and-collection",
        routeId: categoryAndCollectionRouteId,
        isReactRoute: false,
      },
      {
        id: "product-export",
        label: "Product export",
        labelKey: "menu.productExport",
        icon: IconProductExport,
        route: "/products/export",
        routeId: productExportRouteId,
        isReactRoute: false,
      },
      {
        id: "variation-grouping",
        label: "Variation Grouping",
        labelKey: "menu.variationGrouping",
        icon: IconVariationGrouping,
        route: "/products/variation-grouping",
        routeId: variationGroupingRouteId,
        isReactRoute: false,
      },
    ],
  },
  {
    id: "purchasing",
    label: "Purchasing",
    labelKey: "menu.purchasing",
    icon: IconPurchasing,
    children: [
      {
        id: "purchase-orders",
        label: "Purchase Orders",
        labelKey: "menu.purchaseOrders",
        icon: IconPurchaseOrder,
        route: "/purchasing/purchase-order",
        routeId: poRouteId,
        isReactRoute: false,
      },
      {
        id: "containers",
        label: "Containers",
        labelKey: "menu.containers",
        icon: IconContainer,
        route: "/purchasing/container",
        routeId: containerRouteId,
        isReactRoute: false,
      },
      {
        id: "shipments",
        label: "Shipments",
        labelKey: "menu.shipments",
        icon: IconShipment,
        route: "/purchasing/shipment",
        routeId: shipmentRouteId,
        isReactRoute: false,
      },
      {
        id: "vendors",
        label: "Vendors",
        labelKey: "menu.vendors",
        icon: IconVendors,
        route: "/purchasing/vendors",
        routeId: vendorsRouteId,
        isReactRoute: false,
      },
    ],
  },
  {
    id: "jobs",
    label: "Jobs",
    labelKey: "menu.jobs",
    icon: IconJobs,
    children: [
      {
        id: "view-jobs",
        label: "View Jobs",
        labelKey: "menu.viewJobs",
        icon: IconViewJobs,
        route: "/jobs",
        routeId: jobsRouteId,
        isReactRoute: false,
      },
    ],
  },
  {
    id: "inventory",
    label: "Inventory",
    labelKey: "menu.inventory",
    icon: IconInventory,
    children: [
      {
        id: "incoming-inventory",
        label: "Incoming Inventory",
        labelKey: "menu.incomingInventory",
        icon: IconIncomingInventory,
        route: "/inventory-report/incoming-inventory",
        routeId: incomingInventoryRouteId,
        isReactRoute: false,
      },
      {
        id: "archived-inventory",
        label: "Archived Inventory",
        labelKey: "menu.archivedInventory",
        icon: IconIncomingInventory,
        route: "/inventory-report/archived-inventory",
        routeId: archivedInventoryRouteId,
        isReactRoute: false,
      },
      {
        id: "out-of-stock",
        label: "Out of stock",
        labelKey: "menu.outOfStock",
        icon: IconStock,
        route: "/inventory-report/out-stock-report",
        routeId: outOfStockRouteId,
        isReactRoute: false,
      },
      {
        id: "in-stock",
        label: "In-Stock",
        labelKey: "menu.inStockReport",
        icon: IconStock,
        route: "/inventory-report/in-stock-report",
        routeId: inStockRouteId,
        isReactRoute: false,
      },
      {
        id: "all-products",
        label: "All Products",
        labelKey: "menu.allProducts",
        icon: IconInventory,
        // Was "/inventory-report/all-products-inventory" — doesn't exist in
        // Vue's router (real path is allProductsInventoryUrl in
        // RW-ERP-Service/src/types/inventory/inventory-constants.ts). Vue's
        // catch-all then redirected to '/', landing on Vue's default Orders
        // page, which bounced straight back into React via its own
        // redirectToReactApp guard — looked like a React->Vue->React loop.
        route: "/inventory-report/all-stocks-report",
        routeId: allProductsInventoryRouteId,
        isReactRoute: false,
      },
      {
        id: "spi-intelligence",
        label: "SPI Intelligence",
        labelKey: "menu.spiIntelligence",
        icon: IconSpi,
        route: APP_ROUTES.spiInventory,
        // TODO: replace with routeId + ROUTE_PERMISSIONS entry once backend
        // provisions the SPI UUID. Until then this React-only page bypasses
        // the permission gate via `skipPermissionCheck`.
        skipPermissionCheck: true,
        isReactRoute: true,
      },
      // {
      //   id: "spi-buyers",
      //   label: "Buyer Accountability",
      //   labelKey: "menu.spiBuyers",
      //   icon: IconSpi,
      //   route: APP_ROUTES.spiBuyers,
      //   // React-only sub-view of SPI — same provisional permission bypass as
      //   // SPI Intelligence above.
      //   skipPermissionCheck: true,
      //   isReactRoute: true,
      // },
      // {
      //   id: "spi-settings",
      //   label: "SPI Settings",
      //   labelKey: "menu.spiSettings",
      //   icon: IconSpi,
      //   route: APP_ROUTES.spiSettings,
      //   // React-only sub-view of SPI — same provisional permission bypass as
      //   // SPI Intelligence above.
      //   skipPermissionCheck: true,
      //   isReactRoute: true,
      // },
      {
        id: "spi-360view",
        label: "360VIEW",
        labelKey: "menu.spi360view",
        icon: IconSpi,
        route: APP_ROUTES.spi360view,
        // React-only sub-view of SPI — same provisional permission bypass as
        // SPI Intelligence above. Replace with routeId once the backend
        // provisions a 360view UUID.
        skipPermissionCheck: true,
        isReactRoute: true,
      },
    ],
  },
  {
    id: "accounting",
    label: "Accounting",
    labelKey: "menu.accounting",
    icon: IconAccounting,
    children: [
      {
        id: "ar-contacts",
        label: "AR Contacts",
        labelKey: "menu.arContacts",
        icon: IconArContacts,
        route: APP_ROUTES.arContacts,
        routeId: arContactsRouteId,
        isReactRoute: true,
      },
      {
        /*
          CloseHub — month-end close, migrated from the standalone
          close.rwfinapp.net app. Real `tbl_routes` UUID wired 2026-08-06
          (`closeHubRouteId` — route master row created via Settings →
          Route Management, grants via Roles → Manage Permissions), so the
          tab now shows only for users whose role holds the route grant.
          This route gate is IN ADDITION to CloseHub's domain-based
          access/role gate (`useCloseHubIdentity` reads the RW-Users-Service
          "Accounting Close Hub" domain from the shared permission
          snapshot) — the domain gate stays the authority for role
          (admin/reviewer/preparer/viewer) and hard-denies inside the
          feature; this routeId only governs menu-tab and top-level route
          visibility.
        */
        id: "closehub",
        label: "CloseHub",
        labelKey: "menu.closeHub",
        icon: IconCloseHub,
        route: APP_ROUTES.closeHubChecklist,
        routeId: closeHubRouteId,
        isReactRoute: true,
      },
    ],
  },
  {
    id: "marketing",
    label: "Marketing",
    labelKey: "menu.marketing",
    icon: IconMarketing,
    children: [
      {
        id: "amazon-ads",
        label: "Ads Reconciliation",
        labelKey: "menu.amazonAds",
        icon: IconMarketing,
        route: APP_ROUTES.amazonAds,
        routeId: amazonAdsRouteId,
        isReactRoute: true,
      },
    ],
  },
  {
    // Vue parity — `AsideMenu.vue` key 'shipments' (top-level rail, distinct
    // from Purchasing → Shipment above). Leaf ids are prefixed `shipments-`
    // to stay unique against the Orders → Sales orders ids that share the
    // same distributor names (amazon-po, baldor, us-foods-cs).
    id: "shipments-rail",
    label: "Shipments",
    labelKey: "menu.shipmentsRail",
    icon: IconShipments,
    children: [
      {
        id: "shipments-amazon-po",
        label: "Amazon PO",
        labelKey: "menu.shipmentsAmazonPo",
        icon: IconAmazonPo,
        route: "/shipments/amazon-po",
        routeId: shipmentsAmazonPoRouteId,
        isReactRoute: false,
      },
      {
        id: "shipments-amazon-canada",
        label: "Amazon Canada",
        labelKey: "menu.shipmentsAmazonCanada",
        icon: IconAmazonPo,
        route: "/shipments/amazon-canada",
        routeId: shipmentsAmazonPoCanadaRouteId,
        isReactRoute: false,
      },
      {
        id: "shipments-us-foods-cs",
        label: "US Foods CS",
        labelKey: "menu.shipmentsUsFoodsCs",
        icon: IconUsFoods,
        route: "/shipments/us-foods-cs",
        routeId: shipmentsUsFoodsRouteId,
        isReactRoute: false,
      },
      {
        id: "shipments-baldor",
        label: "Baldor",
        labelKey: "menu.shipmentsBaldor",
        icon: IconBaldor,
        route: "/shipments/baldor",
        routeId: shipmentsBaldorRouteId,
        isReactRoute: false,
      },
    ],
  },
  {
    id: "sourcing",
    label: "Team Dashboard",
    labelKey: "menu.sourcing",
    icon: IconSourcing,
    children: [
      {
        id: "asana-sourcing",
        label: "Sourcing",
        labelKey: "menu.asanaSourcingTeam",
        icon: IconSourcing,
        route: APP_ROUTES.asanaSourcing,
        routeId: asanaSourcingRouteId,
        isReactRoute: true,
      },
      {
        id: "asana-purchasing",
        label: "Purchasing",
        labelKey: "menu.asanaPurchasingTeam",
        icon: IconSourcing,
        route: APP_ROUTES.asanaPurchasing,
        routeId: asanaPurchasingRouteId,
        isReactRoute: true,
      },
    ],
  },
  {
    id: "settings",
    label: "Settings",
    labelKey: "menu.settings",
    icon: IconApiKey,
    children: [
      {
        id: "api-keys",
        label: "API keys",
        labelKey: "menu.apiKeys",
        icon: IconApiKey,
        route: APP_ROUTES.apiKeys,
        routeId: apiKeysRouteId,
        isReactRoute: true,
      },
    ],
  },
];
